import { KEYS } from "platejs";
import {
  BoldPlugin,
  ItalicPlugin,
  UnderlinePlugin,
  StrikethroughPlugin,
  CodePlugin,
} from "@platejs/basic-nodes/react";
import { HighlightPlugin } from "@platejs/basic-nodes/react";
import { BlockquotePlugin } from "@platejs/basic-nodes/react";
import {
  BulletedListPlugin,
  ListItemPlugin,
  ListItemContentPlugin,
  NumberedListPlugin,
} from "@platejs/list-classic/react";
import { LinkPlugin } from "@platejs/link/react";
import { HorizontalRulePlugin } from "@platejs/basic-nodes/react";
import { ParagraphPlugin } from "platejs/react";
import { ImagePlugin, PlaceholderPlugin } from "@platejs/media/react";
import { ColumnItemPlugin, ColumnPlugin } from "@platejs/layout/react";
import { IframePlugin } from "./plugins/IframePlugin";
import { DivPlugin } from "./plugins/DivPlugin";
import { ScriptPlugin } from "./plugins/ScriptPlugin";

export const NodeType = {
  PARAGRAPH: ParagraphPlugin.key,
  ORDERED_LIST: NumberedListPlugin.key,
  UNORDERED_LIST: BulletedListPlugin.key,
  LIST_ITEM: ListItemPlugin.key,
  LIST_ITEM_CONTENT: ListItemContentPlugin.key,
  THEMATIC_BREAK: HorizontalRulePlugin.key,
  BLOCK_QUOTE: BlockquotePlugin.key,
  HEADING_ONE: KEYS.h1,
  HEADING_TWO: KEYS.h2,
  HEADING_THREE: KEYS.h3,
  HEADING_FOUR: KEYS.h4,
  HEADING_FIVE: KEYS.h5,
  HEADING_SIX: KEYS.h6,
  LINK: LinkPlugin.key,
  IMAGE: ImagePlugin.key,
  MEDIA_PLACEHOLDER: PlaceholderPlugin.key,
  COLUMN_ITEM: ColumnItemPlugin.key,
  COLUMN_GROUP: ColumnPlugin.key,
  IFRAME: IframePlugin.key,
  SCRIPT: ScriptPlugin.key,
  DIV: DivPlugin.key,
};

export const MarkType = {
  EMPHASIS: ItalicPlugin.key,
  STRONG: BoldPlugin.key,
  UNDERLINE: UnderlinePlugin.key,
  STRIKETHROUGH: StrikethroughPlugin.key,
  CODE: CodePlugin.key,
  HIGHLIGHT: HighlightPlugin.key,
};

export const markdownDefaultMaxLength = 200000;
export const defaultValue = [
  {
    type: NodeType.PARAGRAPH,
    children: [{ text: "" }],
  },
];
